module.exports = __webpack_public_path__ + "media/img/decorations/decoration-offices-right-dca40bb2ab058a0311283c45c5eaf136.svg";